"use strict";

const Accessibility = {
  disclosureEls: [],
  smartCursorEls: [],
  focusTrapEls: [],
  focusOnLoadEls: [],
  init: function () {
    Accessibility.disclosureEls = document.querySelectorAll(".js-disclosure");

    // -- Handle disclosure (accordeon et cie)
    if (Accessibility.disclosureEls.length) {
      Accessibility.disclosureEls.forEach((el) => {
        Accessibility.handleDisclosure(el);
      });
    }

    // -- Apparition des cursors customs au focus
    Accessibility.smartCursorEls = document.querySelectorAll(
      ".smart-cursor-focus"
    );

    if (Accessibility.smartCursorEls.length) {
      window.addEventListener("keyup", Accessibility.handleSmartCursor);
    }

    // -- Piège de focus

    // ---- Modales apparaissant au click sur un bouton d'ouverture
    Accessibility.focusTrapEls = document.querySelectorAll(".js-start-focus-trap");

    if (Accessibility.focusTrapEls.length) {
      Accessibility.focusTrapEls.forEach((triggerBtn) => {
        let modal = document.querySelector(
          `#${triggerBtn.getAttribute("aria-controls")}`
        );
        let closeBtn = modal?.querySelector(".js-end-focus-trap");

        if (modal) {
          Accessibility.handleFocusTrap(triggerBtn, modal, [closeBtn]);
        }
      });
    }

    // ---- Modales présentes directement au chargement de la page
    Accessibility.focusOnLoadEls = document.querySelectorAll(
      ".js-focus-trap.js-global-modal"
    );

    if (Accessibility.focusOnLoadEls.length) {
      Accessibility.focusOnLoadEls.forEach((el) => {
        let closBtns = el.querySelectorAll(".js-end-focus-trap");
        Accessibility.handleFocusTrap(null, el, closBtns);
      });
    }
  },
  handleDisclosure: function (elt) {
    const btn = elt.querySelector(".js-disclosure-toggle");

    btn.addEventListener("click", () => {
      elt.classList.toggle("active");

      if (elt.classList.contains("active")) {
        btn.setAttribute("aria-expanded", "true");
        btn.textContent = btn.getAttribute("data-label-hide");
      } else {
        btn.setAttribute("aria-expanded", "false");
        btn.textContent = btn.getAttribute("data-label-show");
      }
    });
  },
  handleSmartCursor: function (e) {
    if (e.key === "Tab") {
    
      let cursor = null;
      if (
        document.activeElement?.nextElementSibling?.classList?.contains(
          "smart-cursor"
        )
      ) {
        cursor = document.activeElement.nextElementSibling;
      } else if (document.activeElement.querySelector(".smart-cursor")) {
        cursor = document.activeElement.querySelector(".smart-cursor");
      }

      if (
        document.activeElement.classList.contains("smart-cursor-focus") &&
        cursor
      ) {
        const rectParent = cursor.parentElement.getBoundingClientRect();
        const rectCursor = cursor.getBoundingClientRect();
        cursor.style.left = `${rectParent.width / 2 - rectCursor.width / 2}px`;
        cursor.style.top = `${rectParent.height / 2 - rectCursor.height / 2}px`;
      }
    }
  },

  handleFocusTrap: function (triggerBtn, modal, closeBtns) {
    function initFocusTrap(e) {
      const focusableElements = Accessibility.getFocusableElements(modal);
      let isTabPressed = e.key === "Tab" || e.keyCode === 9;
      let isEscPressed = e.key === "Escape" || e.keyCode === 27;

      if (isTabPressed && focusableElements.length) {
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey && document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        } else if (
          (!e.shiftKey && document.activeElement === lastElement) ||
          document.activeElement.tagName === "IFRAME"
        ) {
          e.preventDefault();
          firstElement.focus();
        }
      }

      if (isEscPressed) {
        if (closeBtns.length) {
          closeBtns[closeBtns.length - 1].click();
        }
        window.removeEventListener("keydown", initFocusTrap);
      }
    }

    if (triggerBtn) {
      triggerBtn.addEventListener("click", () => {
        if (Accessibility.getFocusableElements(modal)[0]) {
          Accessibility.getFocusableElements(modal)[0].focus();
        }
        if (triggerBtn.getAttribute("data-popin-title")) {
          modal.setAttribute(
            "aria-label",
            triggerBtn.getAttribute("data-popin-title")
          );
        }
        window.addEventListener("keydown", initFocusTrap);
      });
    } else {
      if (Accessibility.getFocusableElements(modal)[0]) {
        Accessibility.getFocusableElements(modal)[0].focus();
      }
      window.addEventListener("keydown", initFocusTrap);
    }

    if (closeBtns.length) {
      closeBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          if(triggerBtn) triggerBtn.focus()
          window.removeEventListener("keydown", initFocusTrap);
        });
      });
    }
  },
  getFocusableElements: function (parent) {
    const elts = Array.from(
      parent.querySelectorAll(
        'button:not(.hide):not([disabled]), a[href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), iframe, .focus-guard'
      )
    ).filter((el) => {
      // Additional check for visibility and display
      const style = window.getComputedStyle(el);
      return (
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        style.opacity !== "0"
      );
    });

    return elts;
  },
};

export default Accessibility;
